import * as React from 'react';
import styled, { css } from 'styled-components';
import Flex from '@components/layout/flex';
import Avatar from '@components/basics/avatar';
import { ArrowDown } from '@components/basics/icons/arrow-down';
import SimpleArtist from '@common/types/artist/simple-artist';
import User from '@common/types/user/user';

interface NavbarUserAvatarCtrlProps {
  className?: string;
  onHeader?: boolean;
  isSelected?: boolean;
  noTruncate?: boolean;
  noIcons?: boolean;
  isMobile: boolean;
  artist?: SimpleArtist;
  user?: Partial<User>;
  onClick?: () => void;
}

export const NavbarUserAvatarCtrl: React.FC<NavbarUserAvatarCtrlProps> = (
  props
) => {
  return props.artist ? (
    <Flex
      alignItems="center"
      onClick={props.onClick}
      className={props.className}
      gap={7}
    >
      <Avatar
        alt={props.artist.name}
        src={props.artist.avatar}
        size={props.isMobile && props.onHeader ? '26' : undefined}
      />
      <ArrowDown />
    </Flex>
  ) : props.user ? (
    <Flex
      alignItems="center"
      onClick={props.onClick}
      className={props.className}
      gap={7}
    >
      <Avatar
        alt={props.user.name}
        src={props.user.avatar}
        size={props.isMobile && props.onHeader ? '26' : undefined}
      />
      <ArrowDown />
    </Flex>
  ) : null;
};

export default styled(NavbarUserAvatarCtrl)`
  user-select: none;
  background-color: transparent;
  position: relative;
  padding-left: 16px;
  transition: background-color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  @media ${({ theme }) => theme.device.tablet} {
    width: auto;
  }

  ${(props) =>
    props.onHeader
      ? css`
          width: 40px;
          padding: 0;
          border-radius: 90px;
          background-color: ${({ theme }) => theme.colors.midGray};

          &:hover {
            background-color: ${({ theme }) =>
              theme.colors.iconBackgroundHover};
          }

          @media ${({ theme }) => theme.device.tablet} {
            padding: 0;
            height: 40px;
            width: auto;
          }

          @media ${({ theme }) => theme.device.mobileS} {
            padding: 0;
            height: 40px;
            width: auto;
          }

          @media ${({ theme }) => theme.device.laptopS} {
            padding: 5px 10px 5px 5px;
            width: 57px;
          }
        `
      : css`
          .artist-info {
            margin-left: 16px;
          }
        `}
`;
